import React from 'react';
import { Button, Stack, Text } from '@chakra-ui/react';
import { AdditionalPurchaseModal, AdditionalPurchaseQuote } from '@okton/platform-ui';
import { BranchContext } from './types';
import * as api from './aiPlansApi';

export const AiPlanAdditional: React.FC<{ token: string; system: string; context: BranchContext; authorized: boolean }> = props =>
 <AdditionalFlow key={[props.token, props.system, props.context.companyId, props.context.branchId, props.authorized].join(':')} {...props} />;
const AdditionalFlow: React.FC<{ token: string; system: string; context: BranchContext; authorized: boolean }> = ({ token, system, context, authorized }) => {
 const [quote, setQuote] = React.useState<AdditionalPurchaseQuote | null>(null);
 const [loading, setLoading] = React.useState(false);
 const [error, setError] = React.useState('');
 const pending = React.useRef(false);
 const alive = React.useRef(true);
 const controller = React.useRef<AbortController | null>(null);
 React.useEffect(() => () => { alive.current = false; controller.current?.abort(); }, []);
 const open = async () => {
  if (!authorized || pending.current) return;
  pending.current = true; setLoading(true); setError('');
  controller.current = new AbortController();
  try { const result = await api.extraQuote(token, system, context, controller.current.signal); if (alive.current) setQuote(result); }
  catch (reason) { if (alive.current) setError(reason instanceof Error ? reason.message : 'Não foi possível consultar o adicional.'); }
  finally { if (alive.current) { pending.current = false; setLoading(false); } }
 };
 return <Stack spacing="3">
  {authorized ? <Button alignSelf="flex-start" colorScheme="blue" variant="outline" isLoading={loading} isDisabled={loading || !!quote} onClick={open}>Adicionar mais</Button>
   : <Text fontSize="sm">Adicionais não autorizados para esta filial. Consulte o responsável pelo plano.</Text>}
  {error && <Text role="alert" color="red.500">{error}</Text>}
  <AdditionalPurchaseModal isOpen={!!quote} quote={quote} authorized={authorized} onClose={() => setQuote(null)}
   onConfirm={confirmation => api.confirmExtra(token, system, context, confirmation)} />
 </Stack>;
};
